import script from "./BookingsReservationsItem.vue?vue&type=script&setup=true&lang=ts"
export * from "./BookingsReservationsItem.vue?vue&type=script&setup=true&lang=ts"

import "./BookingsReservationsItem.vue?vue&type=style&index=0&id=5b5f7f4a&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5b5f7f4a"]])

export default __exports__